import { defaultFormItemLayout, rules } from '../../../../modules/FormItems'
import React, { Component } from 'react'
import { Col, DatePicker, Divider, Form, Input, Row, Switch } from 'antd'
import { dateVal, strVal } from '../../../../modules/Utils'
import CountrySelect from '../../../../elements/Select/Country'

export function UpdatableForm (props) {
  const {
    newData,
    oldData,
    newPath,
    oldPath,
    label,
    path,
    setFieldsValue,
    getFieldDecorator,
    required = true,
  } = props
  const oldValue = strVal(newData, newPath)
  const newValue = strVal(oldData, oldPath)

  return (
    <Form.Item {...{ ...defaultFormItemLayout, label }}>
      {getFieldDecorator(path, {
        initialValue: newValue ? newValue : oldValue,
        rules: required === true ? rules.input : false,
      })(<Input placeholder={label}/>)}
      {newValue && (
        <span>
          <Row>Registered Value : {newValue}</Row>
          <Row>User Entered : {oldValue}</Row>
          <Row>
            Update :
            <Switch
              onChange={e =>
                setFieldsValue({
                  [path]: e ? oldValue : newValue,
                })
              }
            />
          </Row>
        </span>
      )}
    </Form.Item>
  )
}

class Member extends Component {
  componentDidMount () {
    // setTimeout(() => {
    //   if (this.props.member) {
    //     this.props.lastActionIsNext ? this.props.next() : this.props.prev()
    //   }
    // }, 50)
  }

  render () {
    const { getFieldDecorator, setFieldsValue } = this.props.form
    const { supplierRegistration, member } = this.props
    console.log({ member })

    return (
      <Form className="steps-content">
        <Divider orientation="left">Business Details</Divider>
        <Row>
          <Col span={12}>
            <UpdatableForm
              {...{
                setFieldsValue,
                getFieldDecorator,
                label: 'Registered Name',
                path: 'business.registeredName',
                newData: supplierRegistration,
                newPath: 'business.registeredName',
                oldPath: 'fn',
                oldData: member,
              }}
            />
          </Col>
          <Col span={12}>
            <UpdatableForm
              {...{
                setFieldsValue,
                getFieldDecorator,
                label: 'Trading Name',
                path: 'business.tradingName',
                newData: supplierRegistration,
                newPath: 'business.tradingName',
                oldPath: 'nickname',
                oldData: member,
                required: false,
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <UpdatableForm
              {...{
                setFieldsValue,
                getFieldDecorator,
                label: 'Registration',
                path: 'business.registrationNo',
                newData: supplierRegistration,
                newPath: 'business.registrationNo',
                oldPath: 'code',
                oldData: member,
                required: false,
              }}
            />
          </Col>
          <Col span={12}>
            <Form.Item label="Date" {...defaultFormItemLayout}>
              {getFieldDecorator('dataPrivacyNoticeAcknowledgement.date', {
                initialValue: dateVal(
                  supplierRegistration,
                  'dataPrivacyNoticeAcknowledgement.date',
                ),
                rules: rules.input,
              })(<DatePicker placeholder={'Date'}/>)}
            </Form.Item>
          </Col>
        </Row>
        <Divider orientation="left">Registered Address</Divider>
        <Row>
          <Col span={12}>
            <Form.Item label="Country" {...defaultFormItemLayout}>
              {getFieldDecorator('registeredAddress.country', {
                initialValue: strVal(supplierRegistration, 'registeredAddress.country'),
                rules: rules.input,
              })(<CountrySelect/>)}
              <Row>Registered Value : {strVal(member, 'cob')}</Row>
              <Row>User Entered : {strVal(supplierRegistration, 'registeredAddress.country')}</Row>
              <Row>
                Update :
                <Switch
                  onChange={e =>
                    setFieldsValue({
                      'registeredAddress.country': e
                        ? strVal(supplierRegistration, 'registeredAddress.country')
                        : strVal(member, 'registeredAddress.cob'),
                    })
                  }
                />
              </Row>
            </Form.Item>
          </Col>
          <Col span={12}>
            <UpdatableForm
              {...{
                setFieldsValue,
                getFieldDecorator,
                label: 'State',
                path: 'registeredAddress.state',
                newData: supplierRegistration,
                newPath: 'registeredAddress.state',
                oldPath: 'address.state',
                oldData: member,
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <UpdatableForm
              {...{
                setFieldsValue,
                getFieldDecorator,
                label: 'City',
                path: 'registeredAddress.city',
                newData: supplierRegistration,
                newPath: 'registeredAddress.city',
                oldPath: 'address.city',
                oldData: member,
              }}
            />
          </Col>
          <Col span={12}>
            <UpdatableForm
              {...{
                setFieldsValue,
                getFieldDecorator,
                label: 'Postal Code',
                path: 'registeredAddress.postcode',
                newData: supplierRegistration,
                newPath: 'registeredAddress.postcode',
                oldPath: 'address.postcode',
                oldData: member,
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <UpdatableForm
              {...{
                setFieldsValue,
                getFieldDecorator,
                label: 'Building',
                path: 'registeredAddress.address',
                newData: supplierRegistration,
                newPath: 'registeredAddress.address.line2',
                oldPath: 'address.address',
                oldData: member,
                required: false,
              }}
            />
          </Col>
          <Col span={12}>
            <UpdatableForm
              {...{
                setFieldsValue,
                getFieldDecorator,
                label: 'Street',
                path: 'registeredAddress.street',
                newData: supplierRegistration,
                newPath: 'registeredAddress.address.line1',
                oldPath: 'address.street',
                oldData: member,
                required: false,
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <UpdatableForm
              {...{
                setFieldsValue,
                getFieldDecorator,
                label: 'Telephone Number',
                path: 'registeredAddress.telephoneNo',
                newData: supplierRegistration,
                newPath: 'registeredAddress.telephoneNo',
                oldPath: 'address.tel',
                oldData: member,
                required: false,
              }}
            />
          </Col>
          <Col span={12}>
            <UpdatableForm
              {...{
                setFieldsValue,
                getFieldDecorator,
                label: 'Fax Number',
                path: 'registeredAddress.faxNo',
                newData: supplierRegistration,
                newPath: 'registeredAddress.faxNo',
                oldPath: 'member.faxNo',
                oldData: member,
                required: false,
              }}
            />
          </Col>
        </Row>
      </Form>
    )
  }
}

export default Form.create()(Member)

//street => registeredAddress.address.line1
//address == registeredAddress.address.line2
